"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const SearchIcon = createIcon({
  displayName: "SearchIcon",
  viewBox: "0 0 45 45",
  path: (
    <>
      <path
        d="M41.5,45l-15.75-15.75c-1.25,1-2.69,1.79-4.31,2.38-1.62.58-3.35.88-5.19.88-4.54,0-8.39-1.57-11.53-4.72C1.57,24.64,0,20.79,0,16.25S1.57,7.86,4.72,4.72C7.86,1.57,11.71,0,16.25,0s8.39,1.57,11.53,4.72c3.15,3.15,4.72,6.99,4.72,11.53,0,1.83-.29,3.56-.88,5.19-.58,1.62-1.38,3.06-2.38,4.31l15.75,15.75-3.5,3.5ZM16.25,27.5c3.12,0,5.78-1.09,7.97-3.28,2.19-2.19,3.28-4.84,3.28-7.97s-1.09-5.78-3.28-7.97c-2.19-2.19-4.84-3.28-7.97-3.28s-5.78,1.09-7.97,3.28c-2.19,2.19-3.28,4.84-3.28,7.97s1.09,5.78,3.28,7.97c2.19,2.19,4.84,3.28,7.97,3.28Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default SearchIcon;
